import { LogEntry } from "./models/log-entry.model";

export abstract class LogWriter {

  targetEntry: LogEntry;

  /**
   * Use to implement the actual write of the [Log Entry].
   */
  public abstract writeToLog(): void;

  /**
* Use to finish the process or clean-up any resources.
*/
  public finish(): void {

  }


}
